var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeaderUI',{attrs:{"back":true,"title":"Quotes & Drafts","breadcrumb":"Booking & Shipments > Quotes & Drafts > Get New Quote"}}),_c('KeepAlive',[_c(_vm.currentTab,{tag:"component",on:{"changeTabs":_vm.changeTabs}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }